import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=57cf6972&scoped=true&lang=html&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=57cf6972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf6972",
  null
  
)

component.options.__file = "notification.vue"
export default component.exports